var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.errors),function(item){return _c('label',{key:item,staticClass:"error"},[_vm._v(" "+_vm._s(item)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }